export enum ErrorMessage {
  ORDER_ARTICLETRACKING_REF_NOTFOUND = 'ORDER_ARTICLETRACKING_REF_NOTFOUND',
  ORDER_ARTICLETRACKING_PIN_NOTFOUND = 'ORDER_ARTICLETRACKING_PIN_NOTFOUND',
  ORDER_ARTICLETRACKING_ALREADY_TIDIED = 'ORDER_ARTICLETRACKING_ALREADY_TIDIED',
  ORDER_ARTICLETRACKING_WITH_OPEN_DEFECT = 'ORDER_ARTICLETRACKING_WITH_OPEN_DEFECT',
  ORDER_ARTICLETRACKING_ORDER_ALREADY_FINISH = 'ORDER_ARTICLETRACKING_ORDER_ALREADY_FINISH',
  NO_STORAGE_AVAILABLE = 'NO_STORAGE_AVAILABLE',
  INCORRECT_CREDENTIAL = 'INCORRECT_CREDENTIAL',
  INVALID_TOKEN = 'INVALID_TOKEN',
  ACCOUNT_DISABLED = 'ACCOUNT_DISABLED',
  ORDER_ALREADY_PAID = 'ORDER_ALREADY_PAID',
  ORDER_ALREADY_FINISH = 'ORDER_ALREADY_FINISH',
  ORDER_NOT_PAYABLE = 'ORDER_NOT_PAYABLE',
  NOT_A_DELIVERABLE_ORDER = 'NOT_A_DELIVERABLE_ORDER',
  EMAIL_ALREADY_USED = 'EMAIL_ALREADY_USED',
  NOT_ALLOWED = 'NOT_ALLOWED',
  ORDER_ARTICLETRACKING_IS_NOT_UNTIDIED = 'ORDER_ARTICLETRACKING_IS_NOT_UNTIDIED',
  ORDERBAG_ALREADY_FINISH = 'ORDERBAG_ALREADY_FINISH',
  INVOICE_NOT_AVAILABLE = 'INVOICE_NOT_AVAILABLE',
  ORDER_ARTICLETRACKING_REF_ALREADY_EXIST = 'ORDER_ARTICLETRACKING_REF_ALREADY_EXIST',
  INCORRECT_VALUE = 'INCORRECT_VALUE',
  WRONG_PHONE_CODE = 'WRONG_PHONE_CODE',
  TRACKINGSHEET_NOT_TIDIABLE = 'TRACKINGSHEET_NOT_TIDIABLE',
  INCORRECT_ENDPOINT = 'INCORRECT_ENDPOINT',
  ORDER_PAYMENT_PROCESSING = 'ORDER_PAYMENT_PROCESSING',
  TRACKINGSHEET_NOT_FACTORY_CHECKED = 'TRACKINGSHEET_NOT_FACTORY_CHECKED',
  ORDER_NOT_TEMPORARY = 'ORDER_NOT_TEMPORARY',
  ORDER_NOT_TRANSFERABLE = 'ORDER_NOT_TRANSFERABLE',
  ORDERBAG_ALREADY_CHECKED = 'ORDERBAG_ALREADY_CHECKED',
  ORDERBAG_NOT_CHECKED = 'ORDERBAG_NOT_CHECKED',
  TRACKINGSHEET_NOT_TIDIED = 'TRACKINGSHEET_NOT_TIDIED',
  ORDER_NOT_PAID = 'ORDER_NOT_PAID',
  ORDER_ARTICLETRACKING_ALREADY_FACTORY = 'ORDER_ARTICLETRACKING_ALREADY_FACTORY',
  ORDERBAG_IS_LAST_NOT_FINISH_OF_EMPTY_ORDER = 'ORDERBAG_IS_LAST_NOT_FINISH_OF_EMPTY_ORDER',
  TRANSPORTSHEET_REF_NOTFOUND = 'TRANSPORTSHEET_REF_NOTFOUND',
  TRANSPORTSHEET_INCORRECT = 'TRANSPORTSHEET_INCORRECT',
  TRANSPORTSHEET_ALREADY_YOURS = 'TRANSPORTSHEET_ALREADY_YOURS',
  TRANSPORTSHEET_ALREADY_BOOKED = 'TRANSPORTSHEET_ALREADY_BOOKED',
  TRANSPORTSHEET_WITHOUT_USER = 'TRANSPORTSHEET_WITHOUT_USER',
  TRACKINGSHEET_ALREADY_PTLTOOK = 'TRACKINGSHEET_ALREADY_PTLTOOK',
  TRACKINGSHEET_NOT_PTLTOOK = 'TRACKINGSHEET_NOT_PTLTOOK',
  TRANSPORTSHEET_ALREADY_PRINT = 'TRANSPORTSHEET_ALREADY_PRINT',
  ORDER_KITBATCH_CONTENT_ERROR = 'ORDER_KITBATCH_CONTENT_ERROR',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  TRANSPORTSHEET_NOT_FACTORY_PACK = 'TRANSPORTSHEET_NOT_FACTORY_PACK',
  TRANSPORTSHEET_NOT_YOURS = 'TRANSPORTSHEET_NOT_YOURS',
  TRANSPORTSHEET_ALREADY_USED = 'TRANSPORTSHEET_ALREADY_USED',
  PICKUP_NOT_AVAILABLE = 'PICKUP_NOT_AVAILABLE',
  ORDER_KITBATCHSTOCK_ALREADY_USED = 'ORDER_KITBATCHSTOCK_ALREADY_USED',
  USER_NOT_UNLIMITEDORDERKIT = 'USER_NOT_UNLIMITEDORDERKIT',
  TRANSPORTSHEET_IS_RETURN = 'TRANSPORTSHEET_IS_RETURN',
  TRANSPORTSHEET_IS_NOT_RETURN = 'TRANSPORTSHEET_IS_NOT_RETURN',
  TRANSPORTSHEET_ALREADY_FACTORYSENT = 'TRANSPORTSHEET_ALREADY_FACTORYSENT',
  TRANSPORTSHEET_DISABLED = 'TRANSPORTSHEET_DISABLED',
  TRANSPORTSHEET_USER_DISABLED = 'TRANSPORTSHEET_USER_DISABLED',
  ORDERSHIPRETURN_ALREADY_VALIDATE = 'ORDERSHIPRETURN_ALREADY_VALIDATE',
  ORDERSHIPRETURN_NOT_VALIDATE = 'ORDERSHIPRETURN_NOT_VALIDATE',
  ORDERSHIPRETURN_ALREADY_SHIP = 'ORDERSHIPRETURN_ALREADY_SHIP',
  PHONENUMBER_INVALID = 'PHONENUMBER_INVALID',
  ORDER_NOT_YOURS = 'ORDER_NOT_YOURS',
  ORDER_HOUSE_NOT_EDITABLE = 'ORDER_HOUSE_NOT_EDITABLE',
  ORDER_NOT_CANCELABLE = 'ORDER_NOT_CANCELABLE',
  ADDRESS_INVALID = 'ADDRESS_INVALID',
  CREDIT_NOT_FOUND = 'CREDIT_NOT_FOUND',
  CREDIT_ALREADY_USED = 'CREDIT_ALREADY_USED',
  CREDIT_ALREADY_CANCELLED = 'CREDIT_ALREADY_CANCELLED',
  CREDIT_NOT_EDITABLE = 'CREDIT_NOT_EDITABLE',
  CREDIT_NOT_CANCELABLE = 'CREDIT_NOT_CANCELABLE',
  USER_HAS_UNFINISHED_ORDER = 'USER_HAS_UNFINISHED_ORDER',
  USER_ALREADY_DELETED = 'USER_ALREADY_DELETED',
  ORDER_HAS_OPEN_DEFECTS = 'ORDER_HAS_OPEN_DEFECTS',
  REFERRAL_CODE_INVALID = 'REFERRAL_CODE_INVALID',
  REFERRAL_REFEREE_NOT_ELIGIBLE = 'REFERRAL_REFEREE_NOT_ELIGIBLE',
  REFUND_FAILED = 'REFUND_FAILED',
  MISSING_HOUSE = 'MISSING_HOUSE',
  EMOJI_NOT_ALLOWED = 'EMOJI_NOT_ALLOWED',
}
